<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <b-row>
            <b-col cols="12">
                <FormInput type="text" label="Nombre" name="name" id="name" rules="required" v-model="etiqueta.name" />
            </b-col>
            <b-col cols="12" class="mt-2">
                <FormInput type="color" label="Color" name="color" id="color" rules="required" v-model="etiqueta.color" />
            </b-col>
            <b-col cols="12" class="text-right mt-3">
                <Button type="submit" name="button">
                    CONTINUAR
                </Button>
            </b-col>
        </b-row>
    </ValidationObserver>
</template>

<script>
    export default {
        props: ['etiqueta'],
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.etiqueta.teatro_id = this.teatro.id;
                    this.$emit('terminado');
                }
            },
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        }
    }
</script>